import copy from 'copy-to-clipboard';
import { toast } from 'react-toastify';

import { Icon, Typography } from '@sravni/react-design-system';
import { Copy } from '@sravni/react-icons';

import { CopiedNotification } from '@src/components/CopiedNotification';

import styles from './styles.module.scss';

const { Text } = Typography;

type PromoCodeProps = {
    promoCode: string;
};

export const PromoCode = ({ promoCode }: PromoCodeProps) => {
    const handleClick = () => {
        copy(promoCode);
        toast(<CopiedNotification />, {
            position: 'bottom-right',
            closeButton: false,
            className: styles.toast,
            autoClose: 2000,
        });
    };

    return (
        <div className={styles.root} onClick={handleClick}>
            <div className={styles.content}>
                <Text className="h-color-D60">Ваш промокод</Text>
                <div className={styles.promoCode}>{promoCode}</div>
            </div>
            <div className={styles.copyBlock}>
                <Icon className={styles.arrow} icon={<Copy />} size={20} color="blue" />
            </div>
        </div>
    );
};
